import React from 'react';

import Loadable from 'react-loadable';

import { DefaultExtensionProvider, type Parameters } from '@atlaskit/editor-common/extensions';
import { token } from '@atlaskit/tokens';
import type { CustomSitesExtensionProviderProps } from '@atlassian/company-hub-common';

import {
	HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY,
	HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE,
} from '../../constants';

import { i18n } from './messages';

const HubElementPlaceholderExtension = Loadable({
	loader: async () =>
		(await import('../hub-element-placeholder-extension')).HubElementPlaceholderExtension,
	loading: () => <></>,
});

export const hubElementPlaceholderExtensionProvider = async ({
	contentId,
	editorActions,
	openConfigPanel,
	intl,
}: CustomSitesExtensionProviderProps): Promise<DefaultExtensionProvider<Parameters>> => {
	const type = HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE;
	const title = intl.formatMessage(i18n.title);

	const icons = {
		'48': () =>
			import(
				/* webpackChunkName: "loadable-atlaskitIconCorePremium" */ '@atlaskit/icon/core/premium'
			).then(({ default: PremiumIcon }) => () => (
				<PremiumIcon color={token('color.icon.subtle')} label="" spacing="spacious" />
			)),
	};

	const update = async () => {
		const selectedNode = editorActions?.getSelectedNode()?.toJSON();
		const selectedLocalId = (selectedNode as any)?.attrs?.localId;

		if (!!selectedLocalId && openConfigPanel) {
			openConfigPanel(selectedLocalId);
		}
	};

	const render =
		async () =>
		({ node }: any) => {
			// Only render the extension if we are in the editor
			return editorActions ? (
				<HubElementPlaceholderExtension
					openConfigPanel={openConfigPanel}
					editorActions={editorActions as any}
					extensionNode={node}
					contentId={contentId}
				/>
			) : null;
		};

	return new DefaultExtensionProvider([
		{
			key: HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY,
			icons,
			title,
			type,
			description: '',
			modules: {
				nodes: {
					default: {
						type: 'extension',
						render,
						update,
					},
				},
			},
		},
	]);
};
